/**
 * Keystroke isolation (spec section 8.2). Spread on the panel root and on the pill.
 *
 * React 18 attaches its listeners to every portal container, which here is `document.body`, so a
 * synthetic `stopPropagation` stops the native event at `body` and no `document` or `window` bubble
 * listener (tool shortcuts, ToolFrame Esc, ActionBar F5) ever sees it. `preventDefault` is never called,
 * so typing, Tab, Ctrl+V and the browser's own F5 still work.
 *
 * Do not replace this with a native `addEventListener('keydown', ...)` on the panel element: it would
 * run before React's delegated listener and starve the panel's own React handlers.
 */
import type { KeyboardEvent } from 'react';

const stop = (event: KeyboardEvent): void => {
  event.stopPropagation();
};

export const isolateKeys = {
  onKeyDown: stop,
  onKeyUp: stop,
  onKeyPress: stop,
};
